import { render, staticRenderFns } from "./diffprice.vue?vue&type=template&id=415f7688&scoped=true"
import script from "./diffprice.vue?vue&type=script&lang=js"
export * from "./diffprice.vue?vue&type=script&lang=js"
import style0 from "./diffprice.vue?vue&type=style&index=0&id=415f7688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415f7688",
  null
  
)

export default component.exports